import { useState, useEffect, useCallback } from 'react';
import { FacilityGroupsApi } from '@/api/clients/facility-groups/facility-groups.api';

export const useGetFacilityGroupsForForms = (options = {}) => {
  const { organizationId = null, enabled = true } = options;

  const [facilityGroups, setFacilityGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchFacilityGroups = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const groups = await FacilityGroupsApi.getFacilityGroupsForForms({
        organizationId,
      });
      setFacilityGroups(groups || []);
    } catch (err) {
      setError(
        err.response?.data?.message || 'Failed to fetch facility groups',
      );
      console.error('Error fetching facility groups:', err);
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    fetchFacilityGroups();
  }, [fetchFacilityGroups, enabled]);

  return {
    facilityGroups,
    loading,
    error,
    refetch: fetchFacilityGroups,
  };
};
